import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Core2Config } from "../shared/core2Config";
import { AppletLanguageConatinerHdrModel } from "../../../../../models/aggregates/applet/index";
import { ApiVisa } from "../shared";

@Injectable({ providedIn: "root" })
export class AppletLanguageHdrTenantService extends BaseApiTemplateService<AppletLanguageConatinerHdrModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "applet-language-hdrs/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "applet-language-hdrs/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }

  getAppletLanguageFile(appletGuid: string, languageCode: string, apiVisa: ApiVisa){
    if(apiVisa.api_domain_url){
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + "/" + appletGuid + "/i18n/" + languageCode;
    }
    return this.httpClient.get(this.apiUrl, this.getHttpHeader(apiVisa));
  }
}
